import { render } from "./shopList.vue?vue&type=template&id=62a56847&scoped=true"
import script from "./shopList.vue?vue&type=script&lang=js"
export * from "./shopList.vue?vue&type=script&lang=js"

import "./shopList.vue?vue&type=style&index=0&id=62a56847&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a56847"]])

export default __exports__